/**
 * System version + build channel, baked in at build time by vite's
 * `define` (see vite.config.ts).
 *
 * Version source of truth: package.json `version` — the FE's single bump
 * outlet (CI bumps it before deploy). Channel: the pipeline-set
 * `BUILD_CHANNEL`, else the build-host git branch mapped to a release
 * channel (dev/develop → Alpha, stage/staging → Beta, main/master →
 * Stable; production code name arrives via BUILD_CHANNEL). Mirrors the
 * BE's App\Lib\SystemVersion.
 */
export const SYSTEM_VERSION: string = __APP_VERSION__
export const SYSTEM_CHANNEL: string = __APP_CHANNEL__

/** Canonical UI form, e.g. "v2.0.0 (Alpha)". */
export const systemVersionDisplay = `v${SYSTEM_VERSION} (${SYSTEM_CHANNEL})`
